import {
  Message as MessageType,
  MessageDisplayType,
  MessageGroup,
} from "@/reducers/messagesSlice"
import GroupedForwardedImagesMessage from "./GroupedForwardedImagesMessage"
import GroupedImagesMessage from "@/components/chat/GroupedImagesMessage"
import RetractedMessage from "@/components/chat/RetractedMessage"
import MissedCallMessage from "@/components/chat/MisssedCallMessage"
import ChatHelpers from "@/lib/chatHelpers"
import SlickAIMessage from "@/components/chat/SlickAIMessage"
import GenericMessage from "@/components/chat/GenericMessage"

const MessageReplyTo = ({
  messageOrMessageGroup,
}: {
  messageOrMessageGroup: MessageType | MessageGroup
}) => {
  // Handle grouped images/files (MessageGroup)
  if (messageOrMessageGroup.displayType === MessageDisplayType.MessageGroup) {
    if (messageOrMessageGroup.messages.every((m) => m.forwarded)) {
      return (
        <GroupedForwardedImagesMessage
          messagesGroup={messageOrMessageGroup}
          interactive={false}
        />
      )
    }
    return (
      <GroupedImagesMessage
        messagesGroup={messageOrMessageGroup}
        interactive={false}
      />
    )
  }

  // Handle not grouped messages (Message)
  if (messageOrMessageGroup.displayType === MessageDisplayType.Message) {
    // Retracted messages
    if (messageOrMessageGroup.retracted) {
      return <RetractedMessage message={messageOrMessageGroup} />
    }

    if (messageOrMessageGroup.missedCallNumber) {
      return <MissedCallMessage message={messageOrMessageGroup} />
    }

    // SlickAI messages
    if (ChatHelpers.isMessageFromSlickAI(messageOrMessageGroup.from)) {
      return (
        <SlickAIMessage message={messageOrMessageGroup} interactive={false} />
      )
    }

    // Normal messages (default case)
    return (
      <GenericMessage
        message={messageOrMessageGroup}
        interactive={false}
        showReplay={false}
      />
    )
  }

  return null
}

export default MessageReplyTo
